var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.lpu.drcnt
    ? _c(_setup.InfoCard, {
        attrs: {
          subtitle: `${_setup.numberFormatter.format(
            _vm.lpu.drcnt
          )} ${_setup.tStatic(
            _setup.declensionByNum(_vm.lpu.drcnt, ["врач", "врача", "врачей"])
          )}`,
          icon: "ui-icon-doctor",
        },
        on: { click: _setup.handleClickDoctors },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }